// Sound management: preference persistence + playMatchSound().
// Never autoplays; only plays when explicitly called after a user interaction.
import { createContext, useContext, useCallback, useEffect, useRef, useState } from "react";
import { SOUND_SRC, STORAGE_SOUND } from "../config";

const SoundContext = createContext(null);
export const useSound = () => useContext(SoundContext);

export function SoundProvider({ children }) {
  const [soundOn, setSoundOn] = useState(() => {
    const v = localStorage.getItem(STORAGE_SOUND);
    return v === null ? true : v === "true";
  });
  const audioRef = useRef(null);

  useEffect(() => {
    localStorage.setItem(STORAGE_SOUND, String(soundOn));
  }, [soundOn]);

  const playMatchSound = useCallback(() => {
    if (!soundOn) return;
    try {
      if (!audioRef.current) audioRef.current = new Audio(SOUND_SRC);
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {});
    } catch (e) {
      /* ignore playback errors */
    }
  }, [soundOn]);

  const toggleSound = useCallback(() => setSoundOn((s) => !s), []);

  return (
    <SoundContext.Provider value={{ soundOn, toggleSound, playMatchSound }}>
      {children}
    </SoundContext.Provider>
  );
}
